import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';

function ConfirmDialog({ open, onConfirm, onCancel }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogContent sx={{ pt: 3 }}>
        <Typography>Sei sicuro di voler continuare?</Typography>
        <Typography>I dati non salvati andranno persi.</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          variant="contained"
          sx={{ paddingTop: 1, height: 36, minHeight: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', lineHeight: 1 }}
        >
          ANNULLA
        </Button>
        <Button
          onClick={onConfirm}
          color="warning"
          variant="contained"
          sx={{ paddingTop: 1, height: 36, minHeight: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', lineHeight: 1 }}
        >
          ESCI SENZA SALVARE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
